import cryptoJs from "crypto-js";
import padZeroPadding from "crypto-js/pad-zeropadding";
import Utf8 from "crypto-js/enc-utf8";

const key = cryptoJs.enc.Hex.parse(import.meta.env.VITE_SALT_ENCRYPT);
const iv = cryptoJs.enc.Hex.parse(import.meta.env.VITE_SALT_ENCRYPT);

export const decryptAES = data => {
  try {
    return cryptoJs.AES.decrypt(data, key, {
      iv,
      padding: padZeroPadding,
    }).toString(Utf8);
  } catch (e) {
    return null;
  }
};
